import { ApiResponse, GenericOperationState } from '@repo/core'
import { ConsolidatedPortfolioResponse } from '@repo/position-types'
import { RootState } from '../../../store/types'

export const consolidatedPortfolioSelectorConfig = {
  consolidatedPortfolioSelector: {
    getRootPath: function (
      state: RootState,
    ): GenericOperationState<ApiResponse<ConsolidatedPortfolioResponse> | null> {
      return state.position.master.list.consolidatedPortfolio
    },
  },
  consolidatedPortfolioDownloadSelector: {
    getRootPath: (state: RootState) => state.position.master.list.consolidatedPortfolioDownload,
  },
}
